module.exports = __webpack_public_path__ + "static/media/dor.cae985b7.png";